import createVueComponent from '../createVueComponent';

const SkipForward = createVueComponent('SkipForwardIcon', [
  ['polygon', { points: '5 4 15 12 5 20 5 4', key: '16p6eg' }],
  ['line', { x1: '19', x2: '19', y1: '5', y2: '19', key: 'futhcm' }],
]);

export default SkipForward;
